<script setup lang="ts">
import { HelpTextTooltip, TextField } from '@haskoning/vue-component-library'
import { useCalculationFormComposable } from '@/components/calculation-form/composable/useCalculationFormComposable'
import type { CalculationFormMixinProps } from '@/components/calculation-form/type/type'
import { defineProps, ref } from 'vue'

const props = defineProps<CalculationFormMixinProps>()
const emit = defineEmits(['updateTabCompletion'])
const { calculationStore, currentItem, isValid, formRef, disabled, isReadOnly, hasHelpText } =
  useCalculationFormComposable(props, emit)
defineExpose({ formRef })

const enableOverride = ref<boolean>(false)
const standardParameterFields = [
  'gravity',
  'izbash',
  'mattress_stability_parameter',
  'block_stability_parameter',
  'gabion_stability_parameter',
  'rock_stability_parameter',
  'lift_factor',
  'turbulence_factor',
  'depth_parameter'
]
</script>

<template>
  <v-form ref="formRef" v-model="isValid" :disabled="disabled" :readonly="isReadOnly">
    <v-card elevation="0" flat>
      <v-card-title class="header-font d-flex justify-space-between align-center">
        Standard parameters
        <div class="d-flex justify-end">
          <slot name="resetInputButton" />
        </div>
      </v-card-title>
      <v-card-subtitle class="description-font">
        Parameters usually the same for all projects
      </v-card-subtitle>

      <v-card-text>
        <v-checkbox
          v-model="enableOverride"
          :label="`Enable fields to override default values`"
          hide-details
        />
        <v-row align="center" no-gutters v-for="field in standardParameterFields" :key="field">
          <v-col cols="12" md="8" lg="4" class="d-flex align-center">
            <HelpTextTooltip
              v-if="hasHelpText(field)"
              :text="calculationStore.fields[field].help_text || ''"
            />
            <span :class="hasHelpText(field) ? 'px-2' : 'px-0'">
              {{ calculationStore.fields[field].label }}
            </span>
          </v-col>

          <v-col cols="12" md="8" lg="4" class="pt-0">
            <TextField
              :field="calculationStore.fields[field]"
              :model-value="currentItem"
              :no-help-text="true"
              :disabled="!enableOverride"
              :readonly="isReadOnly"
              @update="calculationStore.update(currentItem)"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<style scoped>
.v-input :deep(.v-input__control) {
  margin-left: -10px;
}

.v-input :deep(.v-input__details) {
  display: none;
}
</style>
